module.exports = __webpack_public_path__ + "img/site-selected.b310538c.svg";